module.exports = "/assets/_next/static/images/incomplete-wand-15b12648b6afdb2a10e8cf0a9da38554.png";